import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import vuetify from './plugins/vuetify';
import ApiService from "./common/api.service";

import store from "./store";
Vue.config.productionTip = false;

ApiService.init();

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");